
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/kyb-workflow-automation",
      function () {
        return require("private-next-pages/use-cases/kyb-workflow-automation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/kyb-workflow-automation"])
      });
    }
  